"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CachePatchFragment = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.CachePatchFragment = (0, graphql_tag_1.default) `
  fragment CachePatchFragment on CachePatchType {
    __typename
    ... on DeleteEntityCachePatchType {
      deletedId
      typename
    }

    ... on InvalidateFieldCachePatchType {
      id
      typename
      fieldName
    }

    ... on UpdateFieldCachePatchType {
      id
      typename
      fieldName
      entityFieldValue {
        ...EntitiFieldValue
      }
    }

    ... on InsertElementCachePatchType {
      id
      typename
      fieldName
      index
      entityFieldValue {
        ...EntitiFieldValue
      }
    }

    ... on RemoveEntityElementCachePatchType {
      id
      typename
      fieldName
      entityId
    }
  }

  fragment EntitiFieldValue on EntityFieldValueType {
    __typename
    stringValue
    booleanValue
    intValue
    floatValue
    entityFieldValueArray {
      __typename
      stringValue
      booleanValue
      intValue
      floatValue
    }
  }
`;
//# sourceMappingURL=cache-instruction-fragment.js.map